import styled, { css, ExecutionContext } from 'styled-components';
import { getColorYig, resolveColor } from 'ui/styles/utils/colors';
import { query } from 'ui/styles/queries';

interface BoxedContentProps {
  $fullHeight?: boolean;
}

const actionPanelDefaults = {
  spacingNormal: '1.25rem',
  spacingBig: '1.5rem',
};

export const BoxedContent = styled.div<BoxedContentProps>`
  ${({ $fullHeight }) => $fullHeight && `height: 100%`}
  margin-bottom: 2rem;
  ${query.phone`
    margin-bottom: 1rem;
  `};
  &:last-child {
    margin-bottom: 0;
  }
`;

function getTextColor({ theme }: ExecutionContext & BoxedContentProps) {
  const colorYig = getColorYig(theme, resolveColor(theme, theme.colors.black));

  return css`
    color: ${colorYig};
  `;
}

export const ActionPanel = styled.div`
  background: ${({ theme }) => theme.colors.black};
  margin: ${actionPanelDefaults.spacingNormal} -${actionPanelDefaults.spacingNormal} -${actionPanelDefaults.spacingNormal};
  padding: ${actionPanelDefaults.spacingNormal} ${actionPanelDefaults.spacingNormal} ${actionPanelDefaults.spacingBig}
    ${actionPanelDefaults.spacingNormal};
  border-radius: 0 0 ${({ theme }) => theme.common.borderRadius} ${({ theme }) => theme.common.borderRadius};

  small {
    ${getTextColor};
  }
`;
